export default "__VITE_ASSET__DfWSnZSK__"